var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCuba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.001 44.522H0V467.478H0.001V256.001V44.522Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.999 511.999C397.383 511.999 511.998 397.384 511.998 256C511.998 114.616 397.383 0.000976562 255.999 0.000976562C114.615 0.000976562 0 114.616 0 256C0 397.384 114.615 511.999 255.999 511.999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 0.00201416C172.249 0.00201416 97.8954 40.225 51.1904 102.402H460.811C414.107 40.224 339.752 0.00201416 256.001 0.00201416V0.00201416Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 511.999C339.753 511.999 414.107 471.776 460.812 409.599H51.1904C97.8944 471.777 172.249 511.999 256.001 511.999Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 256.001C0.000976562 273.536 1.76898 290.658 5.12798 307.201H506.875C510.234 290.658 512.001 273.536 512.001 256.001C512.001 238.466 510.233 221.344 506.875 204.801H5.12798C1.76898 221.344 0.000976562 238.466 0.000976562 256.001V256.001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9807 74.982C-24.9923 174.955 -24.9923 337.046 74.9807 437.021C116.294 395.708 156.026 355.975 256 256.002L74.9807 74.982Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.611 189.219L120.185 240.234H173.831L130.434 271.766L147.008 322.782L103.611 291.252L60.2116 322.782L76.7896 271.766L33.3916 240.234H87.0336L103.611 189.219Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuba);
export default __webpack_public_path__ + "static/media/cuba.9bf61ae5846631825e583ce62a1528d7.svg";
export { ForwardRef as ReactComponent };